import { useFormatMessage } from '~i18n';
import { SrText } from '../sr-text';
import { DotButton, DotsWrapper } from './styled-components';

type Props = {
  activeIndex: number;
  count: number;
  onDotClick(i: number): void;
  dotsActivated: boolean;
};

export const Dots = ({ activeIndex, count, onDotClick, dotsActivated }: Props) => {
  const formatMessage = useFormatMessage();

  return (
    <DotsWrapper
      aria-label={
        formatMessage({
          id: 'comp.carousel.controls',
          defaultMessage: 'Slideshow controls',
        }) as string
      }
    >
      {Array.from({ length: count }).map((_, index) => {
        const isActive = activeIndex === index;

        return (
          // eslint-disable-next-line react/no-array-index-key
          <li key={index}>
            <DotButton
              $active={isActive}
              data-testid="dot-button"
              onClick={() => (dotsActivated ? onDotClick(index) : undefined)}
              tabIndex={dotsActivated ? 0 : -1}
              disabled={isActive}
              aria-hidden={!dotsActivated}
              aria-current={isActive}
              {...{ inert: !dotsActivated ? '' : undefined }}
            />
            <SrText>
              {formatMessage(
                {
                  id: 'comp.carousel.next_button',
                  defaultMessage: 'Go to slide {count} of {count_all}',
                },
                {
                  count: index + 1,
                  count_all: count,
                },
              )}
            </SrText>
          </li>
        );
      })}
    </DotsWrapper>
  );
};
